import React, { useState } from 'react';

const OrderSummary = ({
  subtotal = 0,
  shipping = 0,
  shippingLabel = 'Shirts',
  freeShippingMessage = 'Free shipping & returns on orders over $260.00',
  discountAmount = 0,
  total = 0,
  couponCode = '',

  // ✅ coupon UI is here, but state/actions live in Checkout
  couponInput = '',
  onCouponInputChange,
  onApplyCoupon,
  onRemoveCoupon,
  couponError = '',
  isCouponApplied = false
}) => {

  const [showCoupon, setShowCoupon] = useState(false);
  const shippingCost = Number(shipping || 0);
  const discount = Number(discountAmount || 0);
  const totalAmount = Number(total || 0);

  const toggleCoupon = () => setShowCoupon(!showCoupon);

  return (
    <div className="col-lg-4">
      <div className="custom-summary-box">
        <h5 className="mb-3">Order Details</h5>
        <hr />

        {/* Example Item (You can map real items here if needed) */}
        <div className="d-flex align-items-center justify-content-between mb-5">
          {/* <img src="/assets/images/productImg1.jpg" className="checkout-box-img" alt="Product" /> */}
          <p>Items in Cart</p>
          <p>${Number(subtotal || 0).toFixed(2)}</p>
        </div>

        <hr />
        <div className="d-flex justify-content-between">
          <p>Subtotal</p>
          <p>${Number(subtotal || 0).toFixed(2)}</p>
        </div>
        <div className="d-flex justify-content-between mb-4">
          <p>Shipping ({shippingLabel || 'Shirts'})</p>
          <p>${shippingCost.toFixed(2)}</p>
        </div>

        {discount > 0 && (
          <div className="d-flex justify-content-between mb-4">
            <p>Discount{couponCode ? ` (${couponCode})` : ''}</p>
            <p>- ${discount.toFixed(2)}</p>
          </div>
        )}

        <hr />
        <div className="d-flex justify-content-between fw-bold">
          <p>Total</p>
          <p>${totalAmount.toFixed(2)}</p>
        </div>


        <div className="custom-secure-btn mt-3">
          {freeShippingMessage || 'Free shipping & returns on orders over $260.00'}
        </div>
      </div>

      <div className="container mt-3">
  <div className="custom-tag" onClick={toggleCoupon} style={{ cursor: 'pointer' }}>
    <span>Apply Coupon</span>
    <span className={`custom-arrow ${showCoupon ? 'rotate-up' : ''}`}>&#9660;</span>
  </div>

  {showCoupon && (
    <div className="custom-input-container show">
      <input
        type="text"
        className="form-control"
        placeholder="Enter coupon code"
        value={couponInput || ''}
        onChange={(e) => onCouponInputChange?.(e.target.value)}
      />

      {!isCouponApplied ? (
        <button
          className="btn btn-custom-submit mt-2"
          type="button"
          onClick={onApplyCoupon}
        >
          Submit
        </button>
      ) : (
        <button
          className="btn btn-custom-submit mt-2"
          type="button"
          onClick={onRemoveCoupon}
        >
          Remove
        </button>
      )}

      {couponError ? (
        <div className="mt-2" style={{ color: 'red' }}>{couponError}</div>
      ) : null}
    </div>
  )}
</div>

    </div>
  );
};

export default OrderSummary;
